import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { stat } from 'fs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-challenges-view',
  templateUrl: './challenges-view.component.html',
  styleUrls: ['./challenges-view.component.css']
})
export class ChallengesViewComponent implements OnInit {
  loagActivityData: any = null;
  postoutcomes = [];
  logActivity: Boolean = false;
  logManually: Boolean = false;
  activityData: any;
  chatStatus: Boolean = false;
  chatSticky: Boolean = false;
  comments: Array<any> = [];
  challenge: any;
  archivedOrNot: boolean = true;
  partcipantStatus: any;
  totaldeclined = [];
  totalAccepted = [];
  totalAcceptedOrcompleted = [];
  commentText: any = '';
  allPartcipants: Array<any> = [];
  displayPartcipants: Array<any> = [];
  url = this.apiservice.url + '/uploads/';
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    if (window.pageYOffset >= 10) {
      this.chatSticky = true;
    }
    else {
      this.chatSticky = false;
    }
  }

  ngOnInit() {
    this.loadData();
    this.getAllPartcipants();
    this.loadComments();
    this.loadPartcipantStatus();
  }

  loadData() {
    this.apiservice.getChallengeById({ id: this.route.snapshot.paramMap.get('ch_id') }).subscribe((res: any) => {
      this.challenge = res.data;
      let index = this.challenge.archivedBy.findIndex(data => data == this.apiservice.user._id);
      if (index < 0) {
        this.archivedOrNot = false;
      } else {
        this.archivedOrNot = true;
      }
    })
  }

  loadPartcipantStatus() {
    this.apiservice.getPartcipantStatus({ participant: this.apiservice.user._id, challenge: this.route.snapshot.paramMap.get('ch_id') }).subscribe((res: any) => {
      this.partcipantStatus = res.data;
    })
  }

  getAllPartcipants() {
    this.apiservice.getAllParticipants(this.route.snapshot.paramMap.get('ch_id')).subscribe((res: any) => {
      this.allPartcipants = res.data;
      this.displayPartcipants = this.allPartcipants;
      this.totaldeclined = this.allPartcipants.filter(elem => elem.status == 'Declined');
      this.totalAccepted = this.allPartcipants.filter(elem => elem.status == 'Accepted');
      this.totalAcceptedOrcompleted = this.allPartcipants.filter(elem => (elem.status == 'Accepted' || elem.status == 'Completed'));
    });
  }

  openManualForm(event) {
    this.activityData = event.activityData;
    this.postoutcomes = event.postoutcomes;
    this.logManually = true;
  }

  logActiviy() {
    this.loagActivityData = { category: this.challenge.category._id, goal: this.challenge.goal._id, outcome: this.challenge.outcome._id, activity: this.challenge.activity.title };
    this.logActivity = true;
  }

  formatDate(date) {
    if (date) {
      return moment(date).format('LLL');
    } else {
      null
    }
  }

  filter(event) {
    if (event.target.value == 'all') {
      this.displayPartcipants = this.allPartcipants;
    } else {
      this.displayPartcipants = this.allPartcipants.filter(elem => elem.status == event.target.value);
    }
  }

  loadComments() {
    this.apiservice.getAllcomments(this.route.snapshot.paramMap.get('ch_id')).subscribe((res: any) => {
      this.comments = res.data;
    });
  }

  addComment() {
    var badWords = ['sex', 'fuck', 'dick', 'penis', 'cum', 'tits', 'homo', 'motherfucker', 'pussy', 'boobs', 'boob', 'dick', 'fucker', 'ass'];
    let isBad = false;
    var messageWords = this.commentText.split(' ');
    for (var i = 0; i < messageWords.length; i++) {
      if (badWords.includes(messageWords[i].toLowerCase())) {
        isBad = true;
      }
    }

    if (isBad) {
      this.toastr.warning('We have detected bad words in your input, So this comment can not be submitted.', 'Warning');
      this.commentText = '';
      return
    }
    let formData = new FormData();
    formData.append('challenge', this.route.snapshot.paramMap.get('ch_id'));
    formData.append('addedBy', this.apiservice.user._id);
    formData.append('comment', this.commentText);
    this.apiservice.createComment(formData).subscribe((res: any) => {
      this.loadComments();
      this.commentText = '';
    });
  }

  selectFile(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let formData = new FormData();
      formData.append('challenge', this.route.snapshot.paramMap.get('ch_id'));
      formData.append('addedBy', this.apiservice.user._id);
      formData.append('comment', '');
      formData.append('pic', file);
      this.apiservice.createComment(formData).subscribe((res: any) => {
        this.loadComments();
        this.commentText = '';
      });
    }
  }

  updateStatus(status) {
    this.apiservice.updateParticipant({ id: this.partcipantStatus._id, status: status }).subscribe(() => {
      if (status == 'Completed') {
        this.logActiviy();
      }
      this.loadData();
      this.getAllPartcipants();
      this.loadPartcipantStatus();
    })
  }

  archiveChallenge() {
    this.challenge['archivedBy'].push(this.apiservice.user._id);
    this.apiservice.updateChallenge({ id: this.challenge._id, archivedBy: this.challenge['archivedBy'] }).subscribe(() => {
      this.loadData();
      this.getAllPartcipants();
      this.loadPartcipantStatus();
    });
  }

}
